
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/legal",
      function () {
        return require("private-next-pages/[lang]/legal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/legal"])
      });
    }
  